import { Modal } from 'antd';
import { MODAL_NAME } from 'constants/modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/reducers/modal';
import IDECode from './IDECode';

const PopupViewHistoryCode = () => {
  const { open, data } =
    useSelector((state) => state.modal[MODAL_NAME.HISTORY_CODE]) || {};
  const dispatch = useDispatch();

  const close = () => {
    dispatch(closeModal({ name: MODAL_NAME.HISTORY_CODE }));
  };

  return (
    <Modal
      okText="Run"
      open={open}
      onCancel={close}
      title="Version code"
      className="integration-project"
      footer={null}
    >
      <div className="view-history-code" spellCheck={false}>
        <IDECode
          codeData={JSON.parse(data || '{}')?.content || ''}
          disabledAction
          permissionDisabled
        />
      </div>
    </Modal>
  );
};

export default PopupViewHistoryCode;
